// Local translations
export const T = {
  en_GB: {
    paymentDetails: "Payment details",
    paymentDetailsDesc: "Choose which payment details to display for each portfolio.",
    showAmount: "Show amount",
    showAmountDesc: "Show the payment amount for each portfolio",
    showFrequency: "Show frequency",
    showFrequencyDesc: "Show the recurring payment frequency",
    showDates: "Show dates",
    showDatesDesc: "Show the payment start/end or one-time dates",
  },
  nb_NO: {
    paymentDetails: "Betalingsdetaljer",
    paymentDetailsDesc: "Velg hvilke betalingsdetaljer som skal vises for hver portefølje.",
    showAmount: "Vis beløp",
    showAmountDesc: "Vis betalingsbeløpet for hver portefølje",
    showFrequency: "Vis frekvens",
    showFrequencyDesc: "Vis frekvensen for gjentakende betalinger",
    showDates: "Vis datoer",
    showDatesDesc: "Vis start-/sluttdato eller engangsdato for betalinger",
  },
} as const;
